
        <div class="h-30"></div>
       <div class="review-form-fileds" [hidden]="userProfile.isParticipant">
          <span class="label" >First Name</span>
          <span class="answers">{{userProfile.firstName}}</span>

        </div>

        <div class="review-form-fileds" [hidden]="userProfile.isParticipant">
          <span class="label">Last Name</span>
         <span class="answers">{{userProfile.lastName}}</span>
        <span></span>
      </div>

      <div class="review-form-fileds" [hidden]="!userProfile.isParticipant">
        <span class="label">{{'displayNameText'|translate:translations}}</span>
       <span class="answers">{{userProfile.displayName}}</span>
      <span></span>
    </div>

    <div class="review-form-fileds">
        <span class="label">{{'emailText'|translate:translations}}</span>
       <span class="answers">{{userProfile.emailId}}</span>
      <span></span>
    </div>

    <div class="review-form-fileds">
      <span class="label">{{'provinceText'|translate:translations}}</span>
     <span class="answers">{{userProfile.province}}</span>
    <span></span>
  </div>
      <div class="h-30"></div>
